// import Stores from 'app/private/store/stores'
// import Configuration from 'app/private/settings/configuration'
import { lazy } from 'react'
import { createBrowserRouter, Navigate } from 'react-router-dom'

import { privateLoader, publicLoader } from 'router/helper'
import { permissionData } from 'shared/constants'
import allRoutes from 'shared/lib/allRoutes'

const AuthLayout = lazy(() => import('layout/auth-layout'))
const AdminLayout = lazy(() => import('layout/admin-layout'))

const Login = lazy(() => import('app/auth/login'))
const ForgotPassword = lazy(() => import('app/auth/forgot-password'))
const ResetPassword = lazy(() => import('app/auth/reset-password'))
const Dashboard = lazy(() => import('app/private/dashboard'))
const Attendance = lazy(() => import('app/private/attendence'))
const LeaveManagement = lazy(() => import('app/private/attendence/leave-management'))
const ManageTrips = lazy(() => import('app/private/daily-operations/manage-trips'))
const RateManagement = lazy(() => import('app/private/attendence/rate-management'))
const AddEditRateManagement = lazy(() => import('app/private/attendence/rate-management/add-edit'))
const WorksiteLog = lazy(() => import('app/private/attendence/worksite-logs'))
const Overview = lazy(() => import('app/private/attendence/overview'))
const Manpower = lazy(() => import('app/private/manpower'))
const AddEditManpower = lazy(() => import('app/private/manpower/add-edit'))
const ManpowerDetails = lazy(() => import('app/private/manpower/details'))
const Vehicle = lazy(() => import('app/private/vehicle/index'))
const AddEditVehicle = lazy(() => import('app/private/vehicle/add-edit'))
const VehicalType = lazy(() => import('app/private/vehical-type'))
const AddEditVehicleType = lazy(() => import('app/private/vehical-type/add-edit'))
const Renewals = lazy(() => import('app/private/renewals'))
const AddEditProfile = lazy(() => import('app/private/settings/profile'))
const AddEditPassword = lazy(() => import('app/private/settings/password'))
const Company = lazy(() => import('app/private/settings/company'))
const AddEditCompany = lazy(() => import('app/private/settings/company/add-edit'))
const Competitors = lazy(() => import('app/private/settings/competitors'))
const AddEditCompetitor = lazy(() => import('app/private/settings/competitors/add-edit'))
const WorksiteSetting = lazy(() => import('app/private/settings/worksite'))
const AddEditWorksite = lazy(() => import('app/private/settings/worksite/add-edit'))
const Staff = lazy(() => import('app/private/settings/staff'))
const AddEditStaff = lazy(() => import('app/private/settings/staff/add-edit'))
const Roles = lazy(() => import('app/private/settings/roles'))
const AddEditRoles = lazy(() => import('app/private/settings/roles/add-edit'))
const DocumentDirectory = lazy(() => import('app/private/operational/document-directory'))
const CompetitorsData = lazy(() => import('app/private/operational/competitors-data'))
const HSDConsumption = lazy(() => import('app/private/operational/hsd-consumption'))
// const LubesConsumption = lazy(() => import('app/private/operational/lubes-consumption'))
const InventoryCategory = lazy(() => import('app/private/inverter/inventory-category'))
const AddEditInventoryCategory = lazy(() => import('app/private/inverter/inventory-category/add-edit'))
const Vendor = lazy(() => import('app/private/vendor'))
const AddVendor = lazy(() => import('app/private/vendor/add'))
const PurchaseOrder = lazy(() => import('app/private/store/purchase-order'))
const AddEditPurchaseOrder = lazy(() => import('app/private/store/purchase-order/add-edit'))
const ViewPurchaseOrder = lazy(() => import('app/private/store/purchase-order/view'))
const ReceivedPurchaseOrder = lazy(() => import('app/private/store/purchase-order/received'))
const InventoryManagement = lazy(() => import('app/private/inventory-management'))
const AddInventoryManagement = lazy(() => import('app/private/inventory-management/add-edit'))
const StockHistory = lazy(() => import('app/private/stock-history'))
const PartsIssue = lazy(() => import('app/private/inventory-management/part-issue'))
const ScrapPartsIssue = lazy(() => import('app/private/inventory-management/scrap-part-issue'))
// const DesignationManagement = lazy(() => import('app/private/designation-management'))
const AddEditDesignation = lazy(() => import('app/private/designation-management/add-edit'))
// const DesignationCatManagement = lazy(() => import('app/private/designation-management/category'))
const AddEditDesignationCat = lazy(() => import('app/private/designation-management/category/add-edit'))
const VehicleServiceLog = lazy(() => import('app/private/workshop/vehicle-service-logs'))
const WorkshopVehicleDetails = lazy(() => import('app/private/workshop/vehicle-service-logs/workshop-vehicle-details'))
const Reports = lazy(() => import('app/private/reports'))
const Production = lazy(() => import('app/private/dashboard/production'))
const Statistics = lazy(() => import('app/private/dashboard/statistics'))
const MainDashboard = lazy(() => import('app/private/dashboard/main-dashboard'))
const KeyMetrics = lazy(() => import('app/private/dashboard/key-metrics'))
const Operations = lazy(() => import('app/private/operations'))
const DashboardCompetitorsStats = lazy(() => import('app/private/dashboard/competitors-stats'))
const ReportTbl = lazy(() => import('shared/components/reports/report-details/report-tbl'))
const LeaveDetails = lazy(() => import('shared/components/attandance/leave-management/leave-details'))
const OperationCompetitorsStats = lazy(() => import('app/private/operations/competitors-stats'))
const OperationProductionData = lazy(() => import('app/private/operations/production-data'))
const ProductionTippers = lazy(() => import('app/private/operations/production-data/production-tippers'))
const ProductionTippersTipperNo = lazy(() => import('app/private/operations/production-data/production-tippers/tipper-no'))
const ProductionPayloaders = lazy(() => import('app/private/operations/production-data/production-payloaders'))
const ProductionPayloaderNo = lazy(() => import('app/private/operations/production-data/production-payloaders/payloader-no'))
const OperationManpowerDeployment = lazy(() => import('app/private/operations/manpower-deployment'))
const Equipment = lazy(() => import('app/private/equipment'))
const EquipmentRenewals = lazy(() => import('app/private/equipment/renewals'))
const Workshop = lazy(() => import('app/private/workshop'))
const StoresConsumedPayloaders = lazy(() => import('app/private/stock-consumed/store-consumed-payloader'))
const StoresConsumedPayloadersNo = lazy(() => import('app/private/stock-consumed/store-consumed-payloader/consumed-payloader'))
const StoreConsumedTippers = lazy(() => import('app/private/stock-consumed/store-consumed-tippers'))
const StoresConsumedTippersNo = lazy(() => import('app/private/stock-consumed/store-consumed-tippers/consumed-tipper'))
const StockIssue = lazy(() => import('app/private/stock-issue'))
const StockReturned = lazy(() => import('app/private/stock-returned'))
const ManpowerEmployeeDetail = lazy(() => import('app/private/manpower/manpower-employee-detalls-drivers'))
const Stores = lazy(() => import('app/private/store'))
const Configuration = lazy(() => import('app/private/settings/configuration'))
const StoresConsumedAllOthers = lazy(() => import('app/private/stock-consumed/store-consumed-allothers'))
const StoresConsumedAllOthersNo = lazy(() => import('app/private/stock-consumed/store-consumed-allothers/store-consumed-allothers-no'))

export const routes = (queryClient) =>
  createBrowserRouter([
    {
      element: <AuthLayout />,
      loader: publicLoader,
      children: [
        {
          path: allRoutes.login,
          element: <Login />
        },
        {
          path: allRoutes.forgotPassword,
          element: <ForgotPassword />
        },
        {
          path: allRoutes.resetPassword,
          element: <ResetPassword />
        },
        {
          path: '*',
          element: <Navigate to={allRoutes.login} />
        }
      ]
    },
    {
      element: <AdminLayout />,
      loader: privateLoader(queryClient),
      children: [
        {
          path: allRoutes.dashboard,
          handle: permissionData.VIEW_DASHBOARD,
          element: <Dashboard />
        },
        {
          path: allRoutes.overview,
          handle: permissionData.VIEW_HR_ADMIN,
          element: <Overview />
        },
        {
          path: allRoutes.attendance,
          handle: permissionData.VIEW_ATTENDANCE,
          element: <Attendance />
        },
        {
          path: allRoutes.attendanceVehicleWithAttnId(':id', ':aId', ':name', ':type'),
          handle: permissionData.VIEW_ATTENDANCE,
          element: <Attendance />
        },
        {
          path: allRoutes.attendanceVehicle(':id', ':name', ':type'),
          handle: permissionData.VIEW_ATTENDANCE,
          element: <Attendance />
        },
        {
          path: allRoutes?.leaveManagement,
          handle: permissionData?.LIST_EMPLOYEE_LEAVE,
          element: <LeaveManagement />
        },
        {
          path: allRoutes?.leaveDetails(':id'),
          handle: permissionData?.LIST_EMPLOYEE_LEAVE,
          element: <LeaveDetails />
        },
        {
          path: allRoutes?.worksiteLogs,
          handle: permissionData?.VIEW_MANAGE_WORKSITE,
          element: <WorksiteLog />
        },
        {
          path: allRoutes.manageTrips,
          handle: permissionData.VIEW_EQUIPMENT_DEPLOYMENT,
          element: <ManageTrips />
        },
        {
          path: allRoutes?.rateManagement,
          handle: permissionData.VIEW_RATE_MANAGEMENT,
          element: <RateManagement />
        },
        {
          path: allRoutes?.addRateManagement,
          handle: permissionData.CREATE_RATE_MANAGEMENT,
          element: <AddEditRateManagement />
        },
        {
          path: allRoutes?.editRateManagement(':id'),
          handle: permissionData.EDIT_RATE_MANAGEMENT,
          element: <AddEditRateManagement />
        },
        {
          path: allRoutes?.cloneRateManagement(':id'),
          handle: permissionData.CREATE_RATE_MANAGEMENT,
          element: <AddEditRateManagement />
        },
        {
          path: allRoutes.employeeDetails,
          handle: permissionData.VIEW_MANPOWER_ALL,
          element: <Manpower />
        },
        {
          path: allRoutes.employeeDetailsDrivers,
          handle: permissionData.VIEW_MANPOWER,
          element: <ManpowerEmployeeDetail />
        },
        {
          path: allRoutes.addManpower,
          handle: permissionData.CREATE_MANPOWER,
          element: <AddEditManpower />
        },
        {
          path: allRoutes.addDrivers,
          handle: permissionData.CREATE_MANPOWER,
          element: <AddEditManpower />
        },
        {
          path: allRoutes?.manpowerDriverDetails(':id'),
          handle: permissionData?.GET_MANPOWER,
          element: <ManpowerDetails />
        },
        {
          path: allRoutes?.manpowerOtherDetails(':id'),
          handle: permissionData?.GET_MANPOWER,
          element: <ManpowerDetails />
        },
        {
          path: allRoutes?.editManpower(':id'),
          handle: permissionData?.EDIT_MANPOWER,
          element: <AddEditManpower />
        },
        {
          path: allRoutes?.editDrivers(':id'),
          handle: permissionData?.EDIT_MANPOWER,
          element: <AddEditManpower />
        },
        {
          path: allRoutes?.vehicle,
          handle: permissionData?.VIEW_VEHICLE,
          element: <Vehicle />
        },
        {
          path: allRoutes?.addVehicle,
          handle: permissionData?.CREATE_VEHICLE,
          element: <AddEditVehicle />
        },
        {
          path: allRoutes?.editVehicle(':id'),
          handle: permissionData?.EDIT_VEHICLE,
          element: <AddEditVehicle />
        },
        {
          path: allRoutes?.vehicalType,
          handle: permissionData?.VIEW_MANAGE_EQUIPMENT,
          element: <VehicalType />
        },
        {
          path: allRoutes?.addVehicalType,
          handle: permissionData?.VIEW_MANAGE_EQUIPMENT,
          element: <AddEditVehicleType />
        },
        {
          path: allRoutes?.editVehicleType(':id'),
          handle: permissionData?.VIEW_MANAGE_EQUIPMENT,
          element: <AddEditVehicleType />
        },
        {
          path: allRoutes?.renewals(':type'),
          handle: permissionData?.VIEW_OVERVIEW,
          element: <Renewals />
        },
        {
          path: allRoutes?.settings,
          element: <AddEditProfile />
        },
        {
          path: allRoutes?.password,
          element: <AddEditPassword />
        },
        {
          path: allRoutes?.configuration,
          handle: permissionData?.VIEW_CONFIGURATION,
          element: <Configuration />
        },
        {
          path: allRoutes?.manageCompany,
          handle: permissionData?.VIEW_MANAGE_COMPANY,
          element: <Company />
        },
        {
          path: allRoutes?.addCompany,
          handle: permissionData?.CREATE_MANAGE_COMPANY,
          element: <AddEditCompany />
        },
        {
          path: allRoutes?.editCompany(':id'),
          handle: permissionData?.EDIT_MANAGE_COMPANY,
          element: <AddEditCompany />
        },
        {
          path: allRoutes?.manageCompetitors,
          handle: permissionData?.VIEW_MANAGE_COMPETITOR,
          element: <Competitors />
        },
        {
          path: allRoutes?.addCompetitor,
          handle: permissionData?.CREATE_MANAGE_COMPETITOR,
          element: <AddEditCompetitor />
        },
        {
          path: allRoutes?.editCompetitor(':id'),
          handle: permissionData?.EDIT_MANAGE_COMPETITOR,
          element: <AddEditCompetitor />
        },
        {
          path: allRoutes?.manageWorksiteSetting,
          handle: permissionData?.VIEW_MANAGE_WORKSITE_SETTINGS,
          element: <WorksiteSetting />
        },
        {
          path: allRoutes?.addWorksiteSetting,
          handle: permissionData?.CREATE_MANAGE_WORKSITE_SETTINGS,
          element: <AddEditWorksite />
        },
        {
          path: allRoutes?.editWorksiteSetting(':id'),
          handle: permissionData?.EDIT_MANAGE_WORKSITE_SETTINGS,
          element: <AddEditWorksite />
        },
        {
          path: allRoutes?.staff,
          handle: permissionData?.VIEW_STAFF,
          element: <Staff />
        },
        {
          path: allRoutes?.addStaff,
          handle: permissionData?.CREATE_STAFF,
          element: <AddEditStaff />
        },
        {
          path: allRoutes?.editStaff(':id'),
          handle: permissionData?.EDIT_STAFF,
          element: <AddEditStaff />
        },
        {
          path: allRoutes?.roles,
          handle: permissionData?.VIEW_ROLES,
          element: <Roles />
        },
        {
          path: allRoutes?.addRoles,
          handle: permissionData?.CREATE_ROLES,
          element: <AddEditRoles />
        },
        {
          path: allRoutes?.editRoles(':id'),
          handle: permissionData?.EDIT_ROLES,
          element: <AddEditRoles />
        },
        {
          path: allRoutes?.documentDirectory,
          handle: permissionData?.VIEW_DOCUMENT_DIRECTORY,
          element: <DocumentDirectory />
        },
        {
          path: allRoutes?.competitorsData,
          handle: permissionData?.VIEW_COMPETITOR_TRIP,
          element: <CompetitorsData />
        },
        {
          path: allRoutes?.hsdConsumption,
          handle: permissionData?.VIEW_HSD,
          element: <HSDConsumption />
        },
        // {
        //   path: allRoutes?.lubesConsumption,
        //   handle: permissionData?.VIEW_LUBES,
        //   element: <LubesConsumption />
        // },
        {
          path: allRoutes?.vendor,
          handle: permissionData?.VIEW_VENDOR,
          element: <Vendor />
        },
        {
          path: allRoutes?.addVendor,
          handle: permissionData?.CREATE_VENDOR,
          element: <AddVendor />
        },
        {
          path: allRoutes?.editVendor(':id'),
          handle: permissionData?.EDIT_VENDOR,
          element: <AddVendor />
        },
        {
          path: allRoutes?.inventoryCategory,
          handle: permissionData?.VIEW_PARTS_CATEGORY,
          element: <InventoryCategory />
        },
        {
          path: allRoutes?.addInventoryCategory,
          handle: permissionData?.CREATE_PARTS_CATEGORY,
          element: <AddEditInventoryCategory />
        },
        {
          path: allRoutes?.editInventoryCategory(':id'),
          handle: permissionData?.EDIT_PARTS_CATEGORY,
          element: <AddEditInventoryCategory />
        },
        {
          path: allRoutes?.inventoryManagement,
          handle: permissionData?.VIEW_INVENTORY,
          element: <InventoryManagement />
        },
        {
          path: allRoutes?.addInventoryManagement,
          handle: permissionData?.ADD_INVENTORY,
          element: <AddInventoryManagement />
        },
        {
          path: allRoutes?.editInventoryManagement(':id'),
          handle: permissionData?.UPDATE_INVENTORY,
          element: <AddInventoryManagement />
        },
        {
          path: allRoutes?.workshop,
          handle: permissionData?.VIEW_WORKSHOP,
          element: <Workshop />
        },
        {
          path: allRoutes?.vehicleServiceLog,
          handle: permissionData?.VIEW_WORK_SHOP,
          element: <VehicleServiceLog />
        },
        {
          path: allRoutes?.workshopVehicleDetails(':id'),
          handle: permissionData?.VIEW_WORK_SHOP,
          element: <WorkshopVehicleDetails />
        },
        {
          path: allRoutes?.purchaseOrder,
          handle: permissionData?.VIEW_PURCHASE_ORDER,
          element: <PurchaseOrder />
        },
        {
          path: allRoutes?.addPurchaseOrder,
          handle: permissionData.CREATE_PURCHASE_ORDER,
          element: <AddEditPurchaseOrder />
        },
        {
          path: allRoutes.editPurchaseOrder(':id'),
          handle: permissionData.UPDATE_PURCHASE_ORDER,
          element: <AddEditPurchaseOrder />
        },
        {
          path: allRoutes.viewPurchaseOrder(':id'),
          handle: permissionData.GET_PURCHASE_ORDER,
          element: <ViewPurchaseOrder />
        },
        {
          path: allRoutes.receviedPurchaseOrder(':id'),
          handle: permissionData.UPDATE_PURCHASE_ORDER,
          element: <ReceivedPurchaseOrder />
        },
        {
          path: allRoutes.stores,
          handle: permissionData?.VIEW_STORES,
          element: <Stores />
        },
        {
          path: allRoutes?.storeRecieved,
          handle: permissionData?.VIEW_STORES_RECEIVED,
          element: <StockHistory />
        },
        {
          path: allRoutes.storeIssue,
          handle: permissionData?.VIEW_STORES_ISSUED,
          element: <StockIssue />
        },
        {
          path: allRoutes.storeReturned,
          handle: permissionData?.VIEW_STORES_RETURNED,
          element: <StockReturned />
        },
        {
          path: allRoutes?.partIssue,
          handle: permissionData?.UPDATE_INVENTORY,
          element: <PartsIssue />
        },
        {
          path: allRoutes?.scrapPartIssue,
          handle: permissionData?.UPDATE_INVENTORY,
          element: <ScrapPartsIssue />
        },
        // {
        //   path: allRoutes?.designationManagement,
        //   handle: permissionData?.VIEW_DESIGNATION,
        //   element: <DesignationManagement />
        // },
        {
          path: allRoutes?.addDesignation,
          handle: permissionData?.CREATE_DESIGNATION,
          element: <AddEditDesignation />
        },
        {
          path: allRoutes?.editDesignation(':id'),
          handle: permissionData?.UPDATE_DESIGNATION,
          element: <AddEditDesignation />
        },
        // {
        //   path: allRoutes?.designationCategory,
        //   handle: permissionData?.VIEW_DESIGNATION,
        //   element: <DesignationCatManagement />
        // },
        {
          path: allRoutes?.addDesignationCat,
          handle: permissionData?.CREATE_DESIGNATION,
          element: <AddEditDesignationCat />
        },
        {
          path: allRoutes?.editDesignationCat(':id'),
          handle: permissionData?.UPDATE_DESIGNATION,
          element: <AddEditDesignationCat />
        },
        {
          path: allRoutes?.reports,
          handle: permissionData?.VIEW_REPORTS,
          element: <Reports />
        },
        {
          path: allRoutes?.reporttbl(':reportId'),
          handle: permissionData?.VIEW_REPORTS,
          element: <ReportTbl />
        },
        {
          path: allRoutes?.mainDashboard,
          handle: permissionData?.VIEW_DASHBOARD,
          element: <MainDashboard />
        },
        {
          path: allRoutes?.keyMetrics,
          handle: permissionData?.VIEW_KEY_METRICS,
          element: <KeyMetrics />
        },
        {
          path: allRoutes?.dashboardProduction,
          handle: permissionData?.VIEW_DASHBOARD,
          element: <Production />
        },
        {
          path: allRoutes?.dashboardStats,
          handle: permissionData?.VIEW_DASHBOARD,
          element: <Statistics />
        },
        {
          path: allRoutes?.dashboardCompetitorsStats,
          handle: permissionData?.VIEW_PRODUCTION_DATA_ALL,
          element: <DashboardCompetitorsStats />
        },
        {
          path: allRoutes?.operations,
          handle: permissionData?.VIEW_OPERATIONS,
          element: <Operations />
        },
        {
          path: allRoutes?.operationsCompetitorsStats,
          handle: permissionData?.VIEW_COMPETITORS_DATA,
          element: <OperationCompetitorsStats />
        },
        {
          path: allRoutes?.productionData,
          handle: permissionData?.VIEW_PRODUCTION_DATA,
          element: <OperationProductionData />
        },
        {
          path: allRoutes?.productionTippers,
          handle: permissionData?.VIEW_PRODUCTION_TIPPERS,
          element: <ProductionTippers />
        },
        {
          path: allRoutes?.tipperNo,
          handle: permissionData?.VIEW_PRODUCTION_TIPPERS_BY_NO,
          element: <ProductionTippersTipperNo />
        },
        {
          path: allRoutes?.productionPayloaders,
          handle: permissionData?.VIEW_PRODUCTION_PAYLOADERS,
          element: <ProductionPayloaders />
        },
        {
          path: allRoutes?.payloaderNo,
          handle: permissionData?.VIEW_PRODUCTION_PAYLOADERS_BY_NO,
          element: <ProductionPayloaderNo />
        },
        {
          path: allRoutes?.manpowerDeployment,
          handle: permissionData?.VIEW_MANPOWER_DEPLOYMENT,
          element: <OperationManpowerDeployment />
        },
        {
          path: allRoutes?.equipment,
          handle: permissionData?.VIEW_EQUIPMENT,
          element: <Equipment />
        },
        {
          path: allRoutes?.equipmentRenewals,
          handle: permissionData?.VIEW_OVERVIEW,
          element: <EquipmentRenewals />
        },

        {
          path: allRoutes.hrAdminRenewals,
          handle: permissionData.VIEW_HR_RENEWALS,
          element: <EquipmentRenewals />
        },
        {
          path: allRoutes.storesConsumedTippers,
          handle: permissionData.VIEW_STORES_CONSUMED_TIPPERS,
          element: <StoreConsumedTippers />
        },
        {
          path: allRoutes.storeTipperNo,
          handle: permissionData.VIEW_STORES_CONSUMED_TIPPERS,
          element: <StoresConsumedTippersNo />
        },
        {
          path: allRoutes.storesConsumedPayloaders,
          handle: permissionData.VIEW_STORES_CONSUMED_PAYLOADERS,
          element: <StoresConsumedPayloaders />
        },
        {
          path: allRoutes.storePayloaderNo,
          handle: permissionData.VIEW_STORES_CONSUMED_PAYLOADERS,
          element: <StoresConsumedPayloadersNo />
        },
        {
          path: allRoutes.storesConsumedAllOthers,
          handle: permissionData.VIEW_STORES_CONSUMED_OTHERS,
          element: <StoresConsumedAllOthers />
        },
        {
          path: allRoutes.storesAllOthersNo,
          handle: permissionData.VIEW_STORES_CONSUMED_OTHERS,
          element: <StoresConsumedAllOthersNo />
        },

        {
          path: '*',
          element: <Navigate to={allRoutes.settings} />
        }
      ]
    }
  ])
